export default __webpack_public_path__ + "static/media/GiriFortInfoImage.c96c53d7.webp";